import { Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TeamMessageService } from '@app/service/team-message.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { TeamMessageDetailDialogComponent } from '@app/team-message-detail-dialog/team-message-detail-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
@Component({
  selector: 'app-team-message-quit',
  standalone: true,
  imports: [
    MatDialogTitle, 
    MatDialogContent, 
    MatDialogActions, 
    MatDialogClose, 
    MatButtonModule,
    TranslateModule,
  ],
  templateUrl: './team-message-quit.component.html',
  styleUrl: './team-message-quit.component.css'
})
export class TeamMessageQuitComponent {
  // readonly dialogRef = Inject(MatDialogRef<TeamMessageQuitComponent>);
  constructor(
    public dialogRef: MatDialogRef<TeamMessageQuitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,    
    private teamMessageService: TeamMessageService,
    private location: Location,
    translate: TranslateService, 
    public dialog: MatDialog, 
  ) {
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    console.log(browserLang);    
    translate.setDefaultLang('en');    
    translate.use(browserLangToUse);   
  }
  public markRead() {
    // let 
    // const timeout = 2000;
    // const dialogRef = this.dialog.open(TeamMessageDetailDialogComponent);
    
    // let readObject: any = {teammessage_id: this.messageId, Driver_Id: this.driverId, };
    let readObject: any = this.data.readObject;
    this.teamMessageService.markReadTeamMessage(readObject).subscribe(responseTeamMessageObject => {      
      console.log(`team message mark read complete`);
      // this.disableButton = true;
      this.dialogRef.close();
    });

    // dialogRef.afterOpened().subscribe(_ => {      
    //   setTimeout(() => {
    //      dialogRef.close();
    //   }, timeout)
    // })

  }

}
